var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { localized } from '@lit/localize';
import { CommonPlaceholders } from '../../localization/helpers.js';
import '../icon/Icon.js';
let SearchBar = class SearchBar extends LitElement {
    constructor() {
        super(...arguments);
        this.placeholder = CommonPlaceholders.search();
        this.size = 'medium';
        this.variant = 'primary';
        this.special = false;
        this.value = '';
        this.icon = true;
    }
    onInput(e) {
        const target = e.target;
        this.value = target.value;
        this.dispatchEvent(new CustomEvent('search-change', {
            detail: this.value,
            bubbles: true,
            composed: true,
        }));
    }
    render() {
        return html `
      ${this.label ? html `<div class="label">${this.label}</div>` : ''}
      <div class="field">
        <input-text
          placeholder=${this.placeholder}
          .size=${this.size}
          .variant=${this.variant}
          .special=${this.special}
          .value=${this.value}
          @input-text=${this.onInput}
        ></input-text>
        ${this.icon
            ? html `<basic-icon
              class="search-icon"
              name="search"
              size="16"
            ></basic-icon>`
            : ''}
      </div>
    `;
    }
};
SearchBar.styles = css `
    .label {
      margin-bottom: 4px;
      font-size: 0.9em;
      color: #555;
    }

    /* The magnifier overlays the field on the right edge. input-text owns its
       own shadow DOM (we can't pad its inner <input> from here), so a right
       overlay keeps the icon inside the box without colliding with the
       placeholder, which starts on the left. */
    .field {
      position: relative;
    }
    input-text {
      display: block;
      width: 100%;
    }
    .search-icon {
      position: absolute;
      top: 50%;
      right: 10px;
      transform: translateY(-50%);
      display: flex;
      color: #747474;
      pointer-events: none;
    }
  `;
__decorate([
    property({ type: String })
], SearchBar.prototype, "placeholder", void 0);
__decorate([
    property({ type: String })
], SearchBar.prototype, "size", void 0);
__decorate([
    property({ type: String })
], SearchBar.prototype, "variant", void 0);
__decorate([
    property({ type: Boolean })
], SearchBar.prototype, "special", void 0);
__decorate([
    property({ type: String })
], SearchBar.prototype, "value", void 0);
__decorate([
    property({ type: String })
], SearchBar.prototype, "label", void 0);
__decorate([
    property({ type: Boolean })
], SearchBar.prototype, "icon", void 0);
SearchBar = __decorate([
    localized(),
    customElement('search-bar')
], SearchBar);
export { SearchBar };
//# sourceMappingURL=SearchBar.js.map